<template>
  <div
    flex flex-col-reverse font-kumbhSans
    lg="grid grid-cols-2"
  >
    <DescriptionSide />
    <FormSection />
  </div>
</template>
